import Switcher from '../control/Switcher'
import InputGroup from '../ui-components/InputGroup'

const Indicator = (props) => {
  return (
    <div>
      <div className='row form-group'>
        <label>Helpfulness indicator</label>
        <p>Show percentage of users that found this helpful. Note: this will only show a % after 5 votes have been submitted</p>
        <div className='col-md-12'>
          <Switcher on={props.status} onChange={props.setIndicator} />
        </div>
      </div>
      {
        props.status ? (
          <div className='row topic-helpfulness-indicator_percentage_label'>
            <span className={'topic-helpfulness-indicator_percentage'}>
              80%
            </span>
            <span className='topic-helpfulness-indicator_percentage_label_input'>
              <InputGroup
                title={'Helpfulness indicator label'}
                meta={'The message that shows how many users found this topic helpful'}
                type={'text'}
                onChange={(e) => props.setIndicatorLabel('indicatorLabel', e.target.value)}
                value={props.indicatorLabel}
              />
            </span>
          </div>
        ) : null
      }
    </div>
  )
}

export default Indicator
